import { adminApiUrl, apiUrl, authedFetch } from "./lib/api";

export interface MediaItem {
  id: string;
  title: string;
  filename: string;
  content_type: string;
  size_bytes: number;
  created_at: string;
  uploaded_by: string;
  channel_kind?: "memory" | "dream";
  dream_id?: string | null;
  dream_title?: string | null;
}

async function responseError(response: Response): Promise<string> {
  try {
    const body = await response.json() as { detail?: string };
    return body.detail ?? `Request failed (${response.status})`;
  } catch {
    return `Request failed (${response.status})`;
  }
}

export async function fetchMedia(): Promise<MediaItem[]> {
  const response = await authedFetch("/api/media");
  if (!response.ok) throw new Error(await responseError(response));
  return response.json() as Promise<MediaItem[]>;
}

export async function uploadMedia(file: File, title: string): Promise<MediaItem> {
  const query = new URLSearchParams({ title });
  const response = await authedFetch(adminApiUrl(`/api/admin/media?${query}`), {
    method: "POST",
    headers: {
      "Content-Type": file.type,
      "X-Filename": encodeURIComponent(file.name),
    },
    body: file,
  });
  if (!response.ok) throw new Error(await responseError(response));
  return response.json() as Promise<MediaItem>;
}

export async function fetchMediaPlaybackUrl(item: MediaItem): Promise<string> {
  const response = await authedFetch("/api/playback-session", { method: "POST" });
  if (!response.ok) throw new Error(await responseError(response));
  return apiUrl(`/api/media/${encodeURIComponent(item.id)}/content`);
}

export async function closePlaybackSession(): Promise<void> {
  await fetch(apiUrl("/api/playback-session"), {
    method: "DELETE",
    credentials: "include",
  });
}
